import React from 'react';

interface SurveyContextValue {
  surveyId: number;
  targetUserId: number;
  actingOnMemberId: number | null;
  isOnBehalf: boolean;
  certId: number | null;
  certName: string | null;
  propertyName: string | null;
  certCategory: string | null;
  effectiveDate: string | null;
  isProfile: boolean;
  memberName: string | null;
  isLockedByProperty: boolean;
  renterActive: boolean;
}

const SurveyContext = React.createContext<SurveyContextValue>({
  surveyId: 0,
  targetUserId: 0,
  actingOnMemberId: null,
  isOnBehalf: false,
  certId: null,
  certName: null,
  propertyName: null,
  certCategory: null,
  effectiveDate: null,
  isProfile: false,
  memberName: null,
  isLockedByProperty: false,
  renterActive: false,
});

export const useSurvey = (): SurveyContextValue =>
  React.useContext(SurveyContext);

export default SurveyContext;
